<template>
  <div class="commercial-vehicle-display container-fluid" role="region">
    <div class="row background-row">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-7 text-center">
            {{ brand }}
            <img
              class="img-responsive center-block"
              src="../../static/images/ford_commercial_logo_white.png"
              alt="ford_commercial_logo_white"
            />
            <h2>We'll manage your fleet. You manage your business.</h2>
            <p>
              If you're looking for a truck that works as hard as you do, you
              want a Built Ford Tough® commercial truck. From vans and passenger
              wagons to pickups and cutaways, we have a tough and rugged vehicle
              that can meet your needs.
            </p>
            <a
              class="btn commercial-btn"
              href="https://capitaltrucks.com/"
              target="_blank"
              >View Commercial Inventory</a
            >
            <img
              class="img-responsive center-block"
              src="../../static/images/ford-commercial-display-vehicles.png"
              alt="Commercial Ford Vehicles"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["brand"],
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.commercial-vehicle-display {
  font-size: 18px;
  color: #fff;
  background-image: url(../../static/images/ford-commercial-bg.jpeg);
  background-size: cover;
  background-position-y: 80%;
}
.commercial-vehicle-display .background-row {
  background: -moz-linear-gradient(
    left,
    rgba(49, 117, 176, 1) 0%,
    rgba(85, 150, 203, 1) 48%,
    rgba(107, 170, 219, 0) 77%,
    rgba(125, 185, 232, 0) 100%
  );
  background: -webkit-linear-gradient(
    left,
    rgba(49, 117, 176, 1) 0%,
    rgba(85, 150, 203, 1) 48%,
    rgba(107, 170, 219, 0) 77%,
    rgba(125, 185, 232, 0) 100%
  );
  background: linear-gradient(
    to right,
    rgba(49, 117, 176, 1) 0%,
    rgba(85, 150, 203, 1) 48%,
    rgba(107, 170, 219, 0) 77%,
    rgba(125, 185, 232, 0) 100%
  );
  padding: 30px 0;
}
.commercial-vehicle-display .commercial-btn {
  background: #fff;
  color: #3175b0 !important;
  font-size: 18px;
  border-radius: 4px;
  padding: 10px 30px;
  margin: 15px auto;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  transform: perspective(1px) translateZ(0);
  -webkit-transition-property: transform;
  transition-property: transform;
}
.commercial-vehicle-display .commercial-btn:hover {
  transform: scale(1.08);
}
@media (max-width: 767px) {
  .commercial-vehicle-display .background-row {
    background: #3175b0;
  }
}
</style>
